module.exports = __webpack_public_path__ + "img/visa.1170e846.svg";